import Vue from 'vue';
import store from './../../store';
import packageUnitTypeTransformer from './../../transformers/packageUnitType';

const success = ({ data }, resolve) => {
  const packageUnitTypes = packageUnitTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllPackageUnitTypes', packageUnitTypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display campaign types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('package_unit_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/packageUnitType/all.js